import { formConstants } from "../../../../constants/cms/form/form.constants";
import { securityHelper } from "../../../../helpers/securityHelper";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { array } from "prop-types";
import { checkForUpdates, checkForUpdatesOneLevel, deepClone, checkForFormUpdates } from "../../../../helpers/objectHelper";
import { elementOrgin } from "../../../../cms/helpers/elementHelper";

const defaultForm = {
  formId: 0,
  eventId: 0,
  isSavable: false,
  editMode: false,
  name: "default form",
  pages: 1,
  formElements: [],
  selectedElement: null,
  currentPage: 1,
  selectedContainer: null,
  eventName: "Jirango",
  submitError: false,
  paths: [],
  survey: false,
};

export function form(state = defaultForm, action) {
  switch (action.type) {
    case formConstants.ATTACH_SUCCESS:
      const sortNo =
        state.formElements.length > 0
          ? Math.max.apply(
              Math,
              state.formElements.map((o) => {
                return o.sortOrder;
              })
            ) + 1
          : 1;
      return {
        ...state,
        formElements: [
          ...state.formElements,
          {
            ...action.element,
            sortOrder: sortNo,
            page: state.currentPage,
            data: JSON.parse(action.element.data),
            contentId: securityHelper.createGuid(),
          },
        ],
        isSavable: true,
      };
    case formConstants.IS_CROPPING:
      return {
        ...state,
        isCropping: action.isCropping,
      };
    case formConstants.UPDATE_FORM_ELEMENT:
      let newFormElements = Array.from(state.formElements);
      let newSelectedElement = state.selectedElement;
      let newSelectedContainer = state.selectedContainer;
      if (Array.isArray(action.element)) {
        action.element.map((ae) => {
          newFormElements = newFormElements.map((el) => {
            if (el.contentId == ae.contentId) {
              let newEl = deepClone(ae);
              if (state && state.selectedElement && state.selectedElement.contentId === el.contentId) {
                newSelectedElement = newEl;
              }
              if (state && state.selectedContainer && state.selectedContainer.contentId === el.contentId) {
                newSelectedContainer = newEl;
              }
              return newEl;
            } else return el;
          });
        });
      } else {
        newFormElements = newFormElements.map((el) => {
          if (el.contentId == action.element.contentId) {
            let newEl = deepClone(action.element);
            if (state && state.selectedElement && state.selectedElement.contentId === el.contentId) {
              newSelectedElement = newEl;
            }
            if (state && state.selectedContainer && state.selectedContainer.contentId === el.contentId) {
              newSelectedContainer = newEl;
            }
            return newEl;
          } else return el;
        });
      }

      return {
        ...state,
        formElements: newFormElements,
        selectedElement: newSelectedElement,
        selectedContainer: newSelectedContainer,
        isSavable: action.conditionCheck ? false : true,
      };

    case formConstants.REMOVE_PAGE:
      let updatedFormElements = [
        ...state.formElements.filter((el) => {
          return el.page !== state.currentPage;
        }),
      ];
      if (state.pages > state.currentPage) {
        updatedFormElements.map((el) => {
          if (el.page === state.currentPage + 1) {
            el.page = el.page - 1;
            return Object.assign({}, el);
          }
        });
      }

      return {
        ...state,
        formElements: updatedFormElements,
        currentPage: state.currentPage - 1,
        pages: state.pages - 1,
        isSavable: true,
      };
    case formConstants.ADD_PAGE:
      return {
        ...state,
        pages: state.pages + 1,
        isSavable: true,
      };
    case formConstants.RESTORE_FORM:
      return {
        ...state,
        formElements: [],
        selectedContainer: null,
        selectedElement: null,
        isSavable: true,
      };
    case formConstants.SCROLL_PAGE:
      let newState = deepClone(state);
      newState.currentPage = action.page;
      return newState;
    case formConstants.DELETE_SUCCESS:
      let updatedForm = Array.from(state.formElements);

      var indexOfRemovedEl = updatedForm.indexOf(action.element);
      if (indexOfRemovedEl > -1) {
        updatedForm.splice(indexOfRemovedEl, 1);
        updatedForm.map((el) => {
          if (el.parentId === action.element.parentId && el.page == action.element.page && el.sortOrder > action.element.sortOrder) {
            el.sortOrder -= 1;
          }
        });
      }

      if (action.element.type === elementConstants.CONTAINER) {
        const containerChildren = updatedForm.filter((el) => el.parentId === action.element.id);
        containerChildren.map((cc) => {
          const childElements = updatedForm.filter((el) => el.parentId == cc.id);
          childElements.map((childEl) => {
            updatedForm.splice(updatedForm.indexOf(childEl), 1);
          });
          updatedForm.splice(updatedForm.indexOf(cc), 1);
        });
      } else if (action.element.type === elementConstants.PAYMENT_OPTIONS) {
        updatedForm = updatedForm.filter((el) => el.type !== elementConstants.INVOICE_FIELD);
      }
      return {
        ...state,
        formElements: updatedForm,
        isSavable: true,
        selectedElement: null,
      };
    case formConstants.DESELECT_SUCCESS:
      return {
        ...state,
        selectedElement: null,
        selectedContainer: null,
        selectedOption: null,
      };
    case formConstants.TRANSFER_SUCCESS:
      return {
        ...state,
        formElements: [
          ...state.formElements.map((el) => {
            if (el.id === action.element.id && el.sortOrder && action.element.sortOrder) {
              el.page = action.element.page;
            }
          }),
        ],
        selectedElement: null,
      };
    case formConstants.SELECT_SUCCESS:
      if (action.element.type === elementConstants.CONTAINER && action.element.parentId === null) {
        const containerId = action.element.id;
        const containerChildId = state.formElements
          .filter((el) => {
            return el.parentId === containerId;
          })
          .map((el) => {
            return el.id;
          });
        const hasChildren = state.formElements.filter((el) => {
          return containerChildId.includes(el.parentId);
        });
        if (hasChildren.length > 0) {
          return {
            ...state,
            selectedContainer: action.element,
          };
        }
      }

      if (
        state.formElements.find((el) => {
          return el.contentId === action.element.contentId;
        }) &&
        action.element.type === elementConstants.CONTAINER &&
        action.element.parentId === null
      ) {
        return {
          ...state,
          selectedContainer: action.element,
          selectedElement: null,
        };
      }
      const parentChild = state.formElements.find((el) => {
        return el.id === action.element.parentId;
      });

      if (parentChild && state.selectedContainer) {
        if (parentChild.parentId === state.selectedContainer.id) {
          return {
            ...state,
            selectedElement: action.element,
          };
        }
      } else {
        return {
          ...state,
          selectedElement: action.element,
          selectedContainer: state.selectedContainer && action.element.parentId !== state.selectedContainer.Id ? null : state.selectedContainer,
        };
      }

    case formConstants.SELECT_OPTION:
      return {
        ...state,
        selectedOption: action.option,
      };
    case formConstants.UPDATE_FORM_SUCCESS:
      var parsedFormElements = Array.from(
        action.form.formElements.map((e) => {
          e.data = JSON.parse(e.data);
          e.data = checkForFormUpdates(e.data, elementOrgin(e.type));
          e.contentId = securityHelper.createGuid();

          //attach a validation mark on all elements for posting purpose
          e.isValid = false;
          if (e.data.hidden === true) {
            e.isValid = true;
          }
          if (e.type === elementConstants.CONTAINER) {
            e.isValid = true;
          }
          if (e.type === elementConstants.CONTENT) {
            e.isValid = true;
          }
          if (e.type === elementConstants.EVENT) {
            e.isValid = true;
          }
          if (e.type === elementConstants.PAYMENT_OPTIONS) {
            e.isValid = true;
          }
          if (e.type === elementConstants.QUESTION && e.props.type === "Text") {
            e.isValid = true;
          }
          if (e.type === elementConstants.QUESTION && e.props.type === "Option" && e.props.requiredMin === 0) {
            e.isValid = true;
          }

          e.forceValidationMessage = false;
          return Object.assign({}, e);
        })
      );

      parsedFormElements = parsedFormElements.sort((a, b) => {
        let x = a.sortOrder;
        let y = b.sortOrder;
        return y < x ? 1 : y > x ? -1 : 0;
      });
      return {
        ...state,
        ...action.form,
        formElements: parsedFormElements,
        lastModified: action.form.lastModified,
        selectedElement: null,
        settings: JSON.parse(action.form.settings),
        isSavable: false,
      };
    case formConstants.SOFT_UPDATE_SUCCESS:
      return {
        ...state,
        ...action.form,
        selectedElement: false,
        isSavable: action.reCreation ? false : true,
      };

    case formConstants.GET_FORM_SUCCESS:
      var parsedFormElements = Array.from(
        action.form.formElements.map((e) => {
          e.data = JSON.parse(e.data);
          e.data = checkForFormUpdates(e.data, elementOrgin(e.type));
          /*          e.data = checkForUpdatesOneLevel(e.data, elementOrgin(e.type)); */
          e.contentId = securityHelper.createGuid();

          //attach a validation mark on all elements for posting purpose
          e.isValid = undefined;
          /* 
                    if (e.type === elementConstants.CONTAINER) {
                      e.isValid = true;
                    }
                    if (e.type === elementConstants.CONTENT) {
                      e.isValid = true;
                    }
                    if (e.type === elementConstants.EVENT) {
                      e.isValid = true;
                    }
                    if (e.type === elementConstants.PAYMENT_OPTIONS) {
                      e.isValid = true;
                    } */
          /*        if (e.type === elementConstants.QUESTION && e.props.type === "Text") {
                   if (e.type === elementConstants.QUESTION && e.props.type === "Text"
                     &&
                     (parseInt(e.data.minCharacters) === 0
                       || e.data.required === false)
                   ) {
                     e.isValid = true;
                   }
                 }
                 if (
                   e.type === elementConstants.QUESTION &&
                   e.props.type === "Option" &&
                   (e.props.requiredMin === 0 ||
                     e.data.required === false)
                 ) {
                   e.isValid = true;
                 }
                 if (e.data.hidden === true) {
                   e.isValid = true;
                 }
                 e.forceValidationMessage = false; */
          return Object.assign({}, e);
        })
      );
      parsedFormElements = parsedFormElements.sort((a, b) => {
        let x = a.sortOrder;
        let y = b.sortOrder;
        return y < x ? 1 : y > x ? -1 : 0;
      });
      return {
        ...state,
        ...action.form,
        formElements: parsedFormElements,
        selectedElement: null,
        currency: action.form.currency,
        currentPage: 1 /* 
        
        eventName: action.form.eventName, */,
        pages: action.form.pages,
        editMode: action.editMode,
        survey: action.form.survey,
      };

    case formConstants.GETALL_FORM_REQUEST:
      return { ...state, loading: true };
    case formConstants.GETALL_FORM_SUCCESS:
      return { ...state, loading: false, forms: action.forms };
    case formConstants.GETALL_FORM_FAILURE:
      return { ...state, loading: false, error: action.error };

    case formConstants.CREATE_FORM_SUCCESS:
      return {
        ...state,
        forms: [...state.forms, { ...action.form }],
      };
    /*     case formConstants.UPDATE_FORM_SETTINGS:
          return {
            ...state,
            forms: [...state.forms, { ...action.form }]
          }; */
    case formConstants.POST_FORM_SUCCESS:
      return {
        ...state,
        submitError: false,
      };
    case formConstants.POST_FORM_FAILURE:
      return {
        ...state,
        submitError: true,
      };
    case formConstants.GET_ALL_FORM_PATHS:
      return {
        ...state,
        paths: action.forms,
      };
    default:
      return state;
  }
}
